export class Team {
    constructor(
        public teamId: string,
        public ownerId: string,
        public season: number,
        public division: string,
        public teamName: string,
        public teamLogo: string,
        public twitter: string,
        public website: string,
        public coachID: string,
        public playsInLigaen: boolean = false
    ) { }
}